// extracted by mini-css-extract-plugin
export default {"root":"GeneralDetails_root__765OA","tnc-label":"GeneralDetails_tnc-label__P9Kr2"};